import { useQuery } from '@tanstack/react-query';

import type { UseQueryOptions } from '@tanstack/react-query';

import { axiosInstance } from '#/guest-aps/services/client';

export type ParkingLotInfo = {
  support_kiosk_to_alpr: boolean;
  allow_switch_to_autopass_member: boolean;
};

type GetParkingLotInfoProps = { id: string };

const getParkingLotInfo = ({ id }: GetParkingLotInfoProps) => {
  return axiosInstance.get<{ data: ParkingLotInfo }>(
    `/kiosk/parkinglots/${id}/info`,
  );
};

export const useParkingLotPaymentInfo = (
  props: GetParkingLotInfoProps,
  options: Omit<
    UseQueryOptions<
      Awaited<ReturnType<typeof getParkingLotInfo>>,
      never,
      ParkingLotInfo
    >,
    'queryFn' | 'queryKey'
  > = {},
) => {
  return useQuery({
    queryFn: () => getParkingLotInfo(props),
    queryKey: ['parkinglotsInfo', props.id],
    select: (data) => data.data.data,
    ...options,
  });
};

type MemberInfo = {
  distributor_name: string;
  has_payment_method: boolean;
  enable_alpr: boolean;
  is_autopass_member: boolean;
};

export type PlateNumberInfo = {
  members_info: MemberInfo[];
};

type GetPlateNumberInfoParams = {
  plate_number: string;
};

export const getPlateNumberInfo = (params: GetPlateNumberInfoParams) => {
  return axiosInstance.get<{ data: PlateNumberInfo }>(
    `/kiosk/pba_members_info`,
    {
      params,
    },
  );
};

export const usePlateNumberInfo = (
  params: GetPlateNumberInfoParams,
  options: Omit<
    UseQueryOptions<
      Awaited<ReturnType<typeof getPlateNumberInfo>>,
      never,
      PlateNumberInfo
    >,
    'queryFn' | 'queryKey'
  > = {},
) => {
  return useQuery({
    queryFn: () => getPlateNumberInfo(params),
    queryKey: ['plateNumberInfo', params.plate_number],
    select: (data) => data.data.data,
    ...options,
  });
};
